import styled from 'styled-components';

const Main = styled.main`
  min-height: calc(100vh - ${(p) => p.theme.general.headerHeight} - 40px);
  background-color: #f0f0f2;
  padding: 0;
  padding-bottom: 110px;
  ${({ theme }) => theme.max('md')`
    margin-top: ${theme.general.headerHeight};
  `}
`;

export default Main;
